import React, { useEffect, useState } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import "./AboutusComponent.css";

export default function AboutBanner() {
  return (
    <div className="about-us-banner">
      <Container>
        <Grid container spacing={2}>
          <Grid item md={19} sm={12} xs={12} className="p-0">
            <h2>
            What started as a mission to introduce Investable Agri Assets and improve agricultural capital evolved into a larger vision: a future where every organisation becomes an ecosystem operator — owning, managing, and monetizing its own network.
</h2>
            {/* GBR, an AAMC and tech company in Bangalore, facilitates Agri-entrepreneurs in bringing commercial farming to life</h2> */}
            {/* GBR is a technology  based  company in Bangalore that enables Agri-business to bring COMMERCIAL FARMING for everyone            </h2> */}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
